import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'ui';
import {Container, Img, TextArea} from '../styles';

const Notification = ({closeToast, latestNotification}) => (
  <Container>
    <Img src={latestNotification.image} />
    <TextArea>
      <div>{latestNotification.text}</div>
      <Link href={latestNotification.link_url} target="_blank" onClick={closeToast}>
        {latestNotification.link_text}
      </Link>
    </TextArea>
  </Container>
);

Notification.propTypes = {
  latestNotification: PropTypes.object,
  closeToast: PropTypes.func,
};

export default Notification;
